import Component from "react-pure-render/component";
import React from "react";
import { addNotificationsForInvalidFields } from "../lib/validationWeb";
import Wysiwyg from "../components/wysiwyg.react";
import InputCustom from "../components/inputCustom.react";
import CheckboxCustom from "../components/checkboxCustom.react";
import MediaEdit from "../components/mediaEdit.react";
import Gallery from "../galleries/gallery.react";
import Modal from "../components/modal.react";
import InputWithError from "../components/inputWithError.react";
import EditSection from "../template/editSection.react";
import RemoveSection from "../template/removeSection.react";
import AddGallery from "../template/addGallery.react";
import AddField from "../field/addField.react";
import Select from "react-select";
import ButtonWithAction from "../components/buttonWithAction.react";

export default class FieldCategory extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.getFieldCategory();
  }

  componentDidUpdate(prevProps) {
    const { params: { placeholder } } = this.props;
    const { params: { placeholder: prevPlaceholder } } = prevProps;
    if (placeholder !== prevPlaceholder) {
      this.getFieldCategory();
    }
  }

  getFieldCategory = () => {
    const {
      actions,
      notificationSystem,
      locales: { locales: { defaultLocale } },
      pages: { pages: { meta: pagesMeta } },
      params: { placeholder }
    } = this.props;
    actions
      .getPages(pagesMeta)
      .then(({ error: pagesError, payload: pagesPayload }) => {
        if (pagesError) {
          addNotificationsForInvalidFields(pagesPayload, notificationSystem);
        } else {
          actions.getFieldCategory(placeholder).then(({ error, payload }) => {
            if (error) {
              addNotificationsForInvalidFields(payload, notificationSystem);
            } else {
              actions
                .getFieldCategoriesTranslationsSections(
                  payload.entities.fieldCategories[payload.result]
                    .fieldCategoryTranslations[defaultLocale].uid
                )
                .then(({ error: sectionsError, payload: sectionsPayload }) => {
                  if (error) {
                    addNotificationsForInvalidFields(
                      payload,
                      notificationSystem
                    );
                  } else {
                    const sections =
                      payload.entities.fieldCategories[payload.result]
                        .fieldCategoryTranslations[defaultLocale].sections;
                    for (let sectionName in sections) {
                      for (let fieldName in sections[sectionName].fields) {
                        if (
                          sections[sectionName].fields[fieldName].fieldType ===
                          "resourceURL"
                        ) {
                          pagesPayload.result.pages.forEach(function(
                            page,
                            index
                          ) {
                            if (
                              `/${pagesPayload.entities.pages[page]
                                .pageTranslations[defaultLocale].slug}` ===
                              sections[sectionName].fields[fieldName].value
                            ) {
                              actions.setEntityField(
                                "fields",
                                sections[sectionName].fields[fieldName].uid,
                                "value",
                                `page:${pagesPayload.entities.pages[page]
                                  .pageTranslations[defaultLocale].uid}`
                              );
                            }
                          });
                        }
                      }
                    }
                  }
                });
            }
          });
        }
      });
  };

  dropAction = () => {
    const {
      settings: { draggingItemUID, hoveringItemUID },
      fields: { fields: { entities: fields } },
      actions,
      notificationSystem
    } = this.props;
    const dragField = fields.get(draggingItemUID);
    const dropField = fields.get(hoveringItemUID);
    actions
      .updateField(fields.get(draggingItemUID), draggingItemUID)
      .then(({ error, payload }) => {
        if (error) {
          addNotificationsForInvalidFields(payload, notificationSystem);
        }
        this.getFieldCategory();
      });
  };

  onResourceUrlSelect = (value, options) => {
    const { actions } = this.props;
    actions.setEntityField(
      "fields",
      options[0].fieldUID,
      "value",
      `page:${options[0].pageUID}`
    );
  };

  openRemoveFieldModal = uid => {
    const { actions } = this.props;
    actions.setIsRemoveFieldModalVisible(uid);
  };

  closeRemoveFieldModal = () => {
    const { actions } = this.props;
    actions.setIsRemoveFieldModalVisible(false);
  };

  removeField = () => {
    const {
      actions,
      fields: { fields: { isRemoveModalVisible } },
      notificationSystem
    } = this.props;
    actions.removeField(isRemoveModalVisible).then(({ error, payload }) => {
      if (error) {
        addNotificationsForInvalidFields(payload, notificationSystem);
      }
      this.getFieldCategory();
    });
    actions.setIsRemoveFieldModalVisible(false);
  };

  generateEditPage = columnNumber => {
    const {
      actions,
      settings: { draggingItemUID, hoveringItemUID },
      params: { placeholder },
      fields: {
        fields: {
          entities: fields,
          isRemoveModalVisible: isRemoveFieldModalVisible,
          isAddModalVisible: isAddFieldModalVisible
        }
      },
      galleries: {
        forms: { createGalleryGalleryItem, createGalleryGalleryItem: {} },
        galleries: {
          entities: galleries,
          isRemoveModalVisible: isRemoveGalleryModalVisible
        }
      },
      notificationSystem,
      fieldCategories: { fieldCategories: { entities: fieldCategories } },
      locales: { locales: { defaultLocale } },
      medias: {
        medias: {
          meta: mediasMeta,
          selectedMediaItem,
          entities: medias,
          loading,
          results: mediasResults
        }
      },
      mediaCategories: {
        mediaCategories: {
          search: mediaCategoriesSearch,
          entities: mediaCategories
        }
      },
      config: { apiHost },
      pageTranslations: { pageTranslations: { isEditMediaFieldModalVisible } },
      galleryItems: {
        galleryItems: {
          isRemoveModalVisible: isRemoveGalleryItemModalVisible,
          isEditModalVisible: isEditGalleryItemModalVisible,
          entities: galleryItems
        }
      },
      sections: {
        forms: {
          createSectionField,
          createSectionGallery,
          createSectionGallery: { isAddModalVisible: isAddGalleryModalVisible }
        },
        sections: {
          entities: sections,
          isRemoveModalVisible: isRemoveSectionModalVisible,
          isEditModalVisible: isEditSectionModalVisible
        }
      },
      pages: { pages: { entities: pages } },
      users: { currentUser }
    } = this.props;

    let isDeveloper = false;
    currentUser &&
      currentUser.get("groups").forEach(function(group) {
        if (group.name === "developer") {
          isDeveloper = true;
        }
      });

    const self = this;
    if (
      fieldCategories.getIn([
        placeholder,
        "fieldCategoryTranslations",
        defaultLocale,
        "sections"
      ])
    ) {
      return fieldCategories
        .getIn([
          placeholder,
          "fieldCategoryTranslations",
          defaultLocale,
          "sections"
        ])
        .valueSeq()
        .sort((a, b) => a.get("sort") - b.get("sort"))
        .map(function(section, sectionIndex) {
          if (section.get("columnNumber") === columnNumber) {
            const fieldsContent = section
              .get("fields")
              .sort(
                (a, b) =>
                  fields.getIn([a.get("uid"), "sort"]) -
                  fields.getIn([b.get("uid"), "sort"])
              )
              .valueSeq()
              .map(function(fieldObject, fieldIndex) {
                let field = fields.get(fieldObject.get("uid"));
                if (field) {
                  const inputCustomProps = {
                    feature: "fields",
                    actions: actions,
                    field: ["value"],
                    entity: field,
                    uid: field.get("uid"),
                    placeholder: field.get("placeholder")
                  };

                  if (field.get("fieldType") === "boolean") {
                    return (
                      <div className="col-xs-12" key={fieldIndex}>
                        <div className="content-wrapper section">
                          <div className="section title">
                            <span>{field.get("name")}</span>
                            {isDeveloper && (
                              <ButtonWithAction
                                action={self.openRemoveFieldModal}
                                actionParams={field.get("uid")}
                                buttonText={"usuń pole"}
                              />
                            )}
                          </div>
                          <CheckboxCustom
                            {...inputCustomProps}
                            checked={field.get("value")}
                            id={field.get("uid")}
                            disabled={false}
                          />
                        </div>
                      </div>
                    );
                  } else if (field.get("fieldType") === "text") {
                    return (
                      <div className="col-xs-12" key={fieldIndex}>
                        <div className="content-wrapper section">
                          <div className="section-title">
                            <span>{field.get("name")}</span>
                            {isDeveloper && (
                              <ButtonWithAction
                                action={self.openRemoveFieldModal}
                                actionParams={field.get("uid")}
                                buttonText={"usuń pole"}
                              />
                            )}
                          </div>
                          <InputCustom {...inputCustomProps} />
                        </div>
                      </div>
                    );
                  } else if (field.get("fieldType") === "rawURL") {
                    return (
                      <div className="col-xs-12" key={fieldIndex}>
                        <div className="content-wrapper section">
                          <div className="section-title">
                            <span>{field.get("name")}</span>
                            {isDeveloper && (
                              <ButtonWithAction
                                action={self.openRemoveFieldModal}
                                actionParams={field.get("uid")}
                                buttonText={"usuń pole"}
                              />
                            )}
                          </div>
                          <InputCustom {...inputCustomProps} />
                        </div>
                      </div>
                    );
                  } else if (field.get("fieldType") === "wysiwyg") {
                    return (
                      <div className="col-xs-12" key={fieldIndex}>
                        <div className="content-wrapper section">
                          <div className="section-title">
                            <span>{field.get("name")}</span>
                            {isDeveloper && (
                              <ButtonWithAction
                                action={self.openRemoveFieldModal}
                                actionParams={field.get("uid")}
                                buttonText={"usuń pole"}
                              />
                            )}
                            <div className="subtitle">
                              Aby zmienić / uzupełnić treść, kliknij poniżej.
                            </div>
                          </div>
                          <Wysiwyg
                            {...inputCustomProps}
                            content={fieldObject.get("value")}
                            id={"wysiwyg" + fieldObject.get("uid")}
                          />
                        </div>
                      </div>
                    );
                  } else if (field.get("fieldType") === "imageURL") {
                    return (
                      <MediaEdit
                        removeAction={
                          isDeveloper ? self.openRemoveFieldModal : undefined
                        }
                        isRemoveFieldModalVisible={isDeveloper ? true : false}
                        key={fieldIndex}
                        meta={mediasMeta}
                        mediasResults={mediasResults}
                        field={field}
                        actions={actions}
                        apiHost={apiHost}
                        medias={medias}
                        mediaCategoriesSearch={mediaCategoriesSearch}
                        mediaCategories={mediaCategories}
                        isEditMediaFieldModalVisible={
                          isEditMediaFieldModalVisible
                        }
                        selectedMediaItem={selectedMediaItem}
                        loading={loading}
                      />
                    );
                  } else if (field.get("fieldType") === "mediaImage") {
                    return (
                      <MediaEdit
                        removeAction={
                          isDeveloper ? self.openRemoveFieldModal : undefined
                        }
                        isRemoveFieldModalVisible={isDeveloper ? true : false}
                        key={fieldIndex}
                        meta={mediasMeta}
                        mediasResults={mediasResults}
                        field={field}
                        actions={actions}
                        apiHost={apiHost}
                        medias={medias}
                        mediaCategoriesSearch={mediaCategoriesSearch}
                        mediaCategories={mediaCategories}
                        isEditMediaFieldModalVisible={
                          isEditMediaFieldModalVisible
                        }
                        selectedMediaItem={selectedMediaItem}
                        loading={loading}
                      />
                    );
                  } else if (field.get("fieldType") === "resourceURL") {
                    let resourceUrlSelectOptions = [];
                    let value = "";
                    pages.forEach(function(page, index) {
                      resourceUrlSelectOptions.push({
                        value: page.getIn([
                          "pageTranslations",
                          defaultLocale,
                          "slug"
                        ]),
                        pageUID: page.getIn([
                          "pageTranslations",
                          defaultLocale,
                          "uid"
                        ]),
                        fieldUID: field.get("uid"),
                        label: page.getIn([
                          "pageTranslations",
                          defaultLocale,
                          "name"
                        ])
                      });
                      if (
                        `/${page.getIn([
                          "pageTranslations",
                          defaultLocale,
                          "slug"
                        ])}` === field.get("value")
                      ) {
                        value = page.getIn([
                          "pageTranslations",
                          defaultLocale,
                          "name"
                        ]);
                      } else if (
                        `page:${page.getIn([
                          "pageTranslations",
                          defaultLocale,
                          "uid"
                        ])}` === field.get("value")
                      ) {
                        value = page.getIn([
                          "pageTranslations",
                          defaultLocale,
                          "name"
                        ]);
                      }
                    });
                    return (
                      <div className="col-xs-12" key={fieldIndex}>
                        <div className="content-wrapper section">
                          <div className="section-title">
                            <span>{field.get("name")}</span>
                            {isDeveloper && (
                              <ButtonWithAction
                                action={self.openRemoveFieldModal}
                                actionParams={field.get("uid")}
                                buttonText={"usuń pole"}
                              />
                            )}
                          </div>
                          <Select
                            name="select-resource-url"
                            value={value}
                            options={resourceUrlSelectOptions}
                            onChange={self.onResourceUrlSelect}
                            clearable={false}
                          />
                        </div>
                      </div>
                    );
                  }
                }
              });
            const galleriesContent = section.getIn(["galleries"])
              ? section
                  .getIn(["galleries"])
                  .valueSeq()
                  .map(function(gallery, index) {
                    gallery = galleries.get(gallery.get("uid"));
                    if (gallery) {
                      const inputCustomProps = {
                        feature: "galleries",
                        actions: actions,
                        entity: gallery,
                        uid: gallery.get("uid"),
                        placeholder: gallery.get("placeholder")
                      };
                      return (
                        <div className="col-xs-12" key={index}>
                          <div className="content-wrapper section">
                            <div className="section-title">
                              <span>{gallery.get("name")}</span>
                              {isDeveloper && (
                                <ButtonWithAction
                                  action={self.openRemoveFieldModal}
                                  actionParams={gallery.get("uid")}
                                  buttonText={"usuń pole"}
                                />
                              )}
                            </div>
                            <InputCustom
                              {...inputCustomProps}
                              field={["name"]}
                            />
                            <Gallery
                              galleryItems={galleryItems}
                              gallery={gallery}
                              createGalleryItemForm={createGalleryGalleryItem}
                              actions={actions}
                              notificationSystem={notificationSystem}
                              mediaCategoriesSearch={mediaCategoriesSearch}
                              medias={medias}
                              mediaCategories={mediaCategories}
                              selectedMediaItem={selectedMediaItem}
                              apiHost={apiHost}
                              isEditGalleryItemModalVisible={
                                isEditGalleryItemModalVisible
                              }
                              isRemoveGalleryItemModalVisible={
                                isRemoveGalleryItemModalVisible
                              }
                              updateDataFromServerAction={self.getFieldCategory}
                              mediasResults={mediasResults}
                              meta={mediasMeta}
                            />
                          </div>
                        </div>
                      );
                    }
                  })
              : "";
            if (sections.get(section.get("uid"))) {
              section = sections.get(section.get("uid"));
              const addFieldFormProps = {
                actions: actions,
                feature: "sections",
                form: createSectionField,
                formName: "createSectionField",
                validateFormField: actions.validateFormFieldSections
              };

              const addGalleryFormProps = {
                actions: actions,
                feature: "sections",
                form: createSectionGallery,
                formName: "createSectionGallery",
                validateFormField: actions.validateFormFieldSections
              };
              const editSectionProps = {
                actions: actions,
                feature: "sections",
                entity: section,
                uid: section.get("uid")
              };
              const addDataObjectUID = fieldCategories.getIn([
                placeholder,
                "fieldCategoryTranslations",
                defaultLocale,
                "uid"
              ]);
              return (
                <section className="row" key={sectionIndex}>
                  <h3 className="col-xs-12">{section.get("name")}</h3>
                  {isDeveloper && (
                    <div className="col-xs-3">
                      <div className="row">
                        <RemoveSection
                          sectionUID={section.get("uid")}
                          objectUID={placeholder}
                          afterEditSuccessAction={self.getFieldCategory}
                          actions={actions}
                          notificationSystem={notificationSystem}
                          isRemoveModalVisible={isRemoveSectionModalVisible}
                        />
                      </div>
                    </div>
                  )}
                  {isDeveloper && (
                    <div className="col-xs-3">
                      <div className="row">
                        <EditSection
                          sectionUID={section.get("uid")}
                          afterEditSuccessAction={self.getFieldCategory}
                          objectUID={placeholder}
                          actions={actions}
                          notificationSystem={notificationSystem}
                          isEditModalVisible={isEditSectionModalVisible}
                          editSectionProps={editSectionProps}
                        />
                      </div>
                    </div>
                  )}
                  {isDeveloper && (
                    <div className="col-xs-3">
                      <div className="row">
                        <AddField
                          afterAddSuccessAction={self.getFieldCategory}
                          objectUID={placeholder}
                          addDataObjectUID={addDataObjectUID}
                          actions={actions}
                          sectionUID={section.get("uid")}
                          notificationSystem={notificationSystem}
                          isAddModalVisible={isAddFieldModalVisible}
                          addFieldFormProps={addFieldFormProps}
                        />
                      </div>
                    </div>
                  )}
                  {isDeveloper && (
                    <div className="col-xs-3">
                      <div className="row">
                        <AddGallery
                          afterAddSuccessAction={self.getFieldCategory}
                          objectUID={placeholder}
                          addDataObjectUID={addDataObjectUID}
                          actions={actions}
                          sectionUID={section.get("uid")}
                          notificationSystem={notificationSystem}
                          isAddModalVisible={isAddGalleryModalVisible}
                          addGalleryFormProps={addGalleryFormProps}
                        />
                      </div>
                    </div>
                  )}
                  <hr />
                  <div className="box-wrapper with-space">
                    <span className="title with-space">
                      {section.get("name")}
                    </span>

                    {fieldsContent}
                    {galleriesContent}
                  </div>
                </section>
              );
            }
          }
        });
    }
  };

  publish = () => {
    const {
      actions,
      params: { placeholder },
      sections: { sections: { entities: sections } },
      fields: { fields: { entities: fields } },
      galleries: { galleries: { entities: galleries } },
      fieldCategories: { fieldCategories: { entities: fieldCategories } },
      locales: { locales: { defaultLocale } },
      notificationSystem
    } = this.props;
    fieldCategories
      .getIn([
        placeholder,
        "fieldCategoryTranslations",
        defaultLocale,
        "sections"
      ])
      .map(function(section, sectionIndex) {
        section.getIn(["fields"]).map(function(field, fieldIndex) {
          actions
            .updateField(fields.get(field.get("uid")), field.get("uid"))
            .then(({ error, payload }) => {
              if (error) {
                addNotificationsForInvalidFields(payload, notificationSystem);
              }
            });
        });
        if (sections.getIn([section, "galleries"])) {
          sections
            .getIn([section, "galleries"])
            .map(function(galleryUID, galleryIndex) {
              actions
                .updateGallery(galleries.get(galleryUID), galleryUID)
                .then(({ error, payload }) => {
                  if (error) {
                    addNotificationsForInvalidFields(
                      payload,
                      notificationSystem
                    );
                  }
                });
            });
        }
      });
  };

  openAddSectionModal() {
    const { actions, params: { placeholder } } = this.props;
    actions.setIsAddFieldCategoryTranslationSectionModalVisible(placeholder);
  }

  closeAddSectionModal() {
    const { actions } = this.props;
    actions.setIsAddFieldCategoryTranslationSectionModalVisible(false);
  }

  addSection() {
    const {
      actions,
      params: { placeholder },
      fieldCategories: { fieldCategories: { entities: fieldCategories } },
      notificationSystem,
      fieldCategoriesTranslations: {
        forms: { createFieldCategoriesTranslationSection: { fields } }
      },
      locales: { locales: { defaultLocale } }
    } = this.props;
    let data = fields.toJS();
    data.sort = 1;
    data.columnNumber = 1;
    actions
      .createFieldCategoriesTranslationSection(
        data,
        fieldCategories.getIn([
          placeholder,
          "fieldCategoryTranslations",
          defaultLocale,
          "uid"
        ])
      )
      .then(({ error, payload }) => {
        if (error) {
          addNotificationsForInvalidFields(payload, notificationSystem);
        } else {
          this.getFieldCategory(placeholder);
        }
      });
    actions.setIsAddFieldCategoryTranslationSectionModalVisible(false);
  }

  render() {
    const {
      fields: { fields: { isRemoveModalVisible } },
      actions,
      fieldCategoriesTranslations: {
        forms: {
          createFieldCategoriesTranslationSection,
          createFieldCategoriesTranslationSection: { isAddModalVisible }
        }
      },
      fieldCategories: { fieldCategories: { entities: fieldCategories } },
      params: { placeholder },
      locales: { locales: { defaultLocale } }
    } = this.props;
    const contentLeft = this.generateEditPage(1);
    const contentRight = this.generateEditPage(2);

    const addSectionFormProps = {
      actions: actions,
      feature: "fieldCategoriesTranslations",
      form: createFieldCategoriesTranslationSection,
      formName: "createFieldCategoriesTranslationSection",
      validateFormField: actions.validateFormFieldFieldCategoriesTranslations
    };

    return (
      <div className="islogged-page">
        <div className="row middle-xs">
          <h2 className="col-xs-8">
            {fieldCategories.getIn([
              placeholder,
              "fieldCategoryTranslations",
              defaultLocale,
              "name"
            ])}
          </h2>
          <div className="col-xs-4">
            <button className="info" onClick={this.openAddSectionModal}>
              dodaj sekcję
            </button>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-8">{contentLeft}</div>
          <div className="col-xs-4">{contentRight}</div>
          <div className="col-xs-12">
            <button className="success publish" onClick={this.publish}>
              zatwierdź
            </button>
          </div>
        </div>
        {isAddModalVisible === placeholder && (
          <Modal
            closeModalAction={this.closeAddSectionModal}
            enterAction={this.addSection}
            handleKeyDownEvent={true}
          >
            <div className="row center-xs middle-xs">
              <h3 className="col-xs-12">Dodaj sekcję</h3>
              <form className="col-xs-12">
                <div className="row middle-xs">
                  <label className="col-xs-12 col-sm-4">Nazwa pola</label>
                  <div className="col-xs-12 col-sm-8">
                    <InputWithError {...addSectionFormProps} field="name" />
                  </div>
                </div>
                <div className="row middle-xs">
                  <label className="col-xs-12 col-sm-4">Placeholder</label>
                  <div className="col-xs-12 col-sm-8">
                    <InputWithError
                      {...addSectionFormProps}
                      field="placeholder"
                    />
                  </div>
                </div>
              </form>
              <div className="col-xs-12">
                <button className="info" onClick={this.addSection}>
                  Dodaj
                </button>
                <button className="info" onClick={this.closeAddSectionModal}>
                  Anuluj
                </button>
              </div>
            </div>
          </Modal>
        )}
        {isRemoveModalVisible && (
          <Modal
            closeModalAction={this.closeRemoveFieldModal}
            enterAction={this.removeField}
            handleKeyDownEvent={true}
          >
            <div className="row">
              <h3 className="col-xs-12">Potwierdź usunięcie</h3>
              <div className="col-xs-12">
                <p>Czy napewno usunąć?</p>
                <button className="error" onClick={this.removeField}>
                  Usuń
                </button>
              </div>
            </div>
          </Modal>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/fieldCategory/fieldCategory.react.js